<template>
    <dialog-template v-bind="$attrs"
        v-on="$listeners"
        :width="'400px'"
        :headerTitle="'选择店铺'"
        @opened="focusIpt"
        @close="initData">
        <operate-process :activeId="activeId"
            :names="[{
                id: 0,
                name: '① 输入店铺号'
            }, {
                id: 1,
                name: '② 超管验证'
            }]" />
        <div class="search-shop" v-if="activeId === 0">
            <div class="search-wrapper">
                <!-- input -->
                <el-input v-model="oldShopVal"
                    ref="elIpt"
                    placeholder="请输入老零售店铺号"
                    @keydown.native.enter="searchShop"
                    @input="shopCodeInputHandler($data, 'oldShopVal')">
                    <span class="suffix"
                        slot="suffix"
                        @click.stop="searchShop">搜索</span>
                </el-input>
                <!-- result -->
                <div class="search-result" v-if="isShowSearch">
                    <ul class="search-result__has" v-if="!searchState.isSearching && searchState.hasResult">
                        <li @click="activeId = 1">
                            <!-- <span class="prev">门店零售</span> -->
                            <img class="prev" src="../images/old_ls_shop_icon.svg" alt="">
                            <span class="next text-popper" v-textPopper>{{ oldShopInfo.shop_name }}</span>
                        </li>
                    </ul>
                    <div v-if="!searchState.isSearching && !searchState.hasResult"
                        class="search-result__no color-999 fs-12 align-c"
                        @click.stop>
                        暂无店铺，请检查后重新搜索
                    </div>
                    <div v-if="searchState.isSearching"
                        class="search-result__loading align-c"
                        @click.stop>
                        <i class="el-icon-loading" />
                    </div>
                </div>
            </div>
            <question-icon placement="top" popperWidth="378">
                <p class="align-c mb-8">店铺号是老零售店铺的唯一标识，可前往老零售店铺后台首页查看</p>
                <img style="width: 520px" src="../images/shop_example.jpg" alt="实例图片">
            </question-icon>
        </div>
        <template v-if="activeId === 1">
            <div class="super-valider align-c align-c pt-20">
                <h1 class="color-333 lh-28 fs-20 fw-600">{{ oldShopInfo.shop_name }}</h1>
                <p class="color-999 fs-12 lh-16">创建时间: {{ oldShopInfo.create_time }}</p>
                <div class="send-code p-12 mt-12">
                    <div class="fx-center">
                        <user-info :maxWidth="'260px'"
                            :userInfo="{
                                avatar: oldShopInfo.super_admin_imgurl || '../../../../assets/images/default_avatar.svg',
                                nickname: oldShopInfo.super_admin_nickname,
                                realname: oldShopInfo.super_admin_realname,
                                gender: oldShopInfo.super_admin_sex
                            }" />
                        <span class="super-admin ml-8">超管</span>
                    </div>
                    <div class="send-code__send mt-12 fx-v-center fx-h-between">
                        <span class="color-333">手机号：{{ encryptPhone(oldShopInfo.super_admin_phone) }}</span>
                        <span :class="isSendCode ? 'has-send' : ''"
                            @click="sendCode">{{ sendMsg }}</span>
                    </div>
                    <template v-if="isSendCode">
                        <el-input v-model="validCode"
                            class="mt-12"
                            ref="codeIpt"
                            placeholder="请输入验证码"
                            :class="isCodeError ? 'code-error' : ''"
                            @focus="isCodeError = false"
                            @keydown.native.enter="confirm"
                            @input="codeInputHandler($data, 'validCode')" />
                    </template>
                </div>
            </div>
            <div class="fx-center" slot="footer">
                <el-button type="primary"
                    size="medium"
                    :disabled="isCodeError || validCode === ''"
                    :loading="isConfirmLoading"
                    @click="confirm">
                    确认
                </el-button>
                <el-button type="default"
                    size="medium"
                    @click="backToLast">
                    上一步
                </el-button>
            </div>
        </template>
    </dialog-template>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, reactive, onBeforeUnmount } from '@vue/composition-api'
import OperateProcess from '@/components/operate_process/operate_process.vue'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { inputLimit, inputCodeLimitReg } from '../../../../utils'
import $fetch from '../../../../api'
import { openMessage } from '../../../../utils/system'
import clone from 'lodash/cloneDeep'

export interface IOldShopInfo {
    old_ls_shop_id: string
    shop_name: string
    super_admin_phone: string
    super_admin_nickname: string
    super_admin_realname: string
    super_admin_imgurl: string
}

export default createComponent({
    setup: (props, ctx) => {
        // reactive
        const activeId = ref(0)
        const isShowSearch = ref(false)
        const isSendCode = ref(false)
        const isCodeError = ref(false)
        const isConfirmLoading = ref(false)
        const oldShopVal = ref('')
        const validCode = ref('')
        const sendMsg = ref('发送验证码')
        const oldShopInfo = ref<IOldShopInfo>({})
        const searchState = reactive({
            isSearching: true,
            hasResult: false
        })

        // not reactive
        let timer: any = null
        const shopCodeInputHandler = inputLimit(/^[\d\w]{0,16}$/)
        const codeInputHandler = inputLimit(inputCodeLimitReg)

        onBeforeMount(() => {
            document.addEventListener('click', hideSearch, false)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', hideSearch, false)
        })

        async function fetchShopData() {
            try {
                const result = await $fetch.post({
                    url: '/membership/migration/searchlsshop',
                    params: {
                        shop_code: oldShopVal.value
                    }
                })
                console.log('老零售店铺信息', clone(result))
                searchState.isSearching = false
                if (result.shop_info && result.shop_info.old_ls_shop_id != null) {
                    oldShopInfo.value = result.shop_info
                    searchState.hasResult = true
                } else {
                    searchState.hasResult = false
                }
            } catch (e) {
                searchState.isSearching = false
                searchState.hasResult = false
                openMessage('error', e.message || '获取老零售店铺信息失败')
            }
        }

        async function startSendCode() {
            try {
                const result = await $fetch.post({
                    url: '/membership/migration/requestlsshopvalidation',
                    params: {
                        ls_shop_id: oldShopInfo.value.old_ls_shop_id
                    }
                })
                console.log('验证码', result)
            } catch (e) {
                initSendCode()
                openMessage('error', e.message || '获取验证码失败')
            }
        }

        async function confirm() {
            try {
                isConfirmLoading.value = true
                const result = await $fetch.post({
                    url: '/membership/migration/validatelsshop',
                    params: {
                        ls_shop_id: oldShopInfo.value.old_ls_shop_id,
                        validation_code: validCode.value 
                    }
                })
                if (result.success) {
                    ctx.emit('update:visible', false)
                    ctx.emit('confirm', oldShopInfo.value)
                } else {
                    isCodeError.value = true
                    isConfirmLoading.value = false
                }
            } catch (e) {
                isConfirmLoading.value = false
                openMessage('error', e.message || '验证失败，请重试')
            }
        }

        function sendCode() {
            if (isSendCode.value) {
                return
            }
            isSendCode.value = true
            ctx.root.$nextTick(() => (ctx.refs.codeIpt as any).focus())
            const sum = 60
            let count = 0
            const intervalFn = () => {
                const result = sum - (count++)
                if (result < 0) {
                    initSendCode()
                } else {
                    sendMsg.value = `已发送(${result})`
                }
            }
            timer = setInterval(intervalFn, 1000)
            intervalFn()
            startSendCode()
        }

        function initSearchShop() {
            activeId.value = 0
            isShowSearch.value = false
            searchState.isSearching = true
            searchState.hasResult = false
            oldShopVal.value = ''
        }

        function initSendCode() {
            timer != null && clearInterval(timer)
            isSendCode.value = false
            isCodeError.value = false
            isConfirmLoading.value = false
            sendMsg.value = '发送验证码'
            validCode.value = ''
        }

        function initData() {
            setTimeout(() => {
                initSearchShop()
                initSendCode()
            }, 600)
        }

        function hideSearch() {
            isShowSearch.value = false
        }

        function searchShop() {
            if (oldShopVal.value === '') {
                return openMessage('error', '店铺号不能为空')
            }
            isShowSearch.value = true
            searchState.isSearching = true
            searchState.hasResult = false
            fetchShopData()
        }

        function backToLast() {
            activeId.value = 0
            focusIpt()
            initSendCode()
        }

        function focusIpt() {
            ctx.root.$nextTick(() => (ctx.refs.elIpt as any).focus())
        }

        // 手机号加密
        function encryptPhone(phone: string) {
            return `${phone.toString().slice(0, 3)}****${phone.slice(-4)}`
        }

        return {
            // data
            isShowSearch,
            isSendCode,
            isCodeError,
            isConfirmLoading,
            activeId,
            searchState,
            sendMsg,
            oldShopVal,
            validCode,
            oldShopInfo,
            // methods
            initData,
            searchShop,
            backToLast,
            focusIpt,
            sendCode,
            encryptPhone,
            shopCodeInputHandler,
            codeInputHandler,
            confirm
        }
    },

    components: {
        OperateProcess,
        QuestionIcon
    }
})
</script>

<style lang="scss" scoped>
.search-shop {
    display: flex;
    align-items: center;
    padding: 20px 0 60px;
    color: #333;

    .search-wrapper {
        position: relative;
        flex: 1;
        margin-right: 12px;

        ::v-deep .el-input {
            position: relative;
            z-index: 1;

            .el-input__inner {
                padding-left: 8px;

                &::placeholder {
                    color: #999;
                }
            }

            .el-input__inner:focus {
                & + .el-input__suffix {
                    .suffix {
                        color: #009688;

                        &::before {
                            background-color: #009688;
                        }
                    }
                }
            }

            .suffix {
                position: relative;
                padding-left: 8px;
                padding-right: 4px;
                font-weight: bold;
                color: #999;
                cursor: pointer;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 1px;
                    background-color: #999;
                }
            }
        }

        .search-result {
            position: absolute;
            left: 0;
            right: 0;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, .1);
            background-color: #fff;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .1);
            overflow: hidden;

            &__has {
                max-height: 320px;
                overflow-y: auto;

                li {
                    display: flex;
                    align-items: center;
                    height: 40px;
                    padding: 0 10px;
                    font-size: 14px;
                    cursor: pointer;

                    &:hover {
                        background-color: #f7f7f7;
                    }

                    &:active {
                        background-color: #ddd;
                    }

                    img.prev {
                        margin-right: 10px;
                    }

                    span.next {
                        flex: 1;
                        width: auto;
                    }
                }
            }

            &__no,
            &__loading {
                height: 40px;
                line-height: 40px;
            }
        }
    }
}

.super-valider {
    .send-code {
        background-color: #f7f7f7;

        .super-admin {
            padding: 0 4px;
            font-size: 12px;
            color: #FAAD14;
            border: 1px solid rgb(250, 173, 20);
        }

        &__send {
            span:nth-child(2) {
                display: inline-block;
                width: 85px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                border: 1px solid #009688;
                border-radius: 4px;
                background-color: #fff;
                color: #009688;
                cursor: pointer;

                &:hover {
                    color: #33ABA0;
                    border-color: #33ABA0;
                }

                &:active {
                    background-color: #E6F5F3;
                }

                &.has-send {
                    border-color: #ddd;
                    color: #999;
                    cursor: not-allowed
                }
            }
        }

        ::v-deep .el-input {
            &.code-error {
                position: relative;
                margin-bottom: 20px;

                &::after {
                    content: '验证码错误，请重新输入';
                    position: absolute;
                    left: 0;
                    bottom: -20px;
                    line-height: 20px;
                    font-size: 12px;
                    color: #ee5b5b;
                }

                .el-input__inner {
                    border-color: #ee5b5b;
                }
            }
        }
    }
}
</style>
